var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.249 4.75C15.249 5.74456 14.8539 6.69839 14.1507 7.40165C13.4474 8.10491 12.4936 8.5 11.499 8.5C10.5044 8.5 9.55061 8.10491 8.84735 7.40165C8.14409 6.69839 7.749 5.74456 7.749 4.75C7.749 3.75544 8.14409 2.80161 8.84735 2.09835C9.55061 1.39509 10.5044 1 11.499 1C12.4936 1 13.4474 1.39509 14.1507 2.09835C14.8539 2.80161 15.249 3.75544 15.249 4.75ZM4 18.868C4.03213 16.9004 4.83634 15.0242 6.23918 13.644C7.64202 12.2639 9.53109 11.4905 11.499 11.4905C13.4669 11.4905 15.356 12.2639 16.7588 13.644C18.1617 15.0242 18.9659 16.9004 18.998 18.868C16.6454 19.9468 14.0871 20.5035 11.499 20.5C8.823 20.5 6.283 19.916 4 18.868Z",
    stroke: "#798CAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fc4f9ab504277e618710f37541a2ddc1.svg";
export { ForwardRef as ReactComponent };